export default __webpack_public_path__ + "static/media/Click4.d76b5aa7.mp3";